import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Motion";
import { INSIGHTS, img } from "@/lib/content";

const Insights = () => (
  <>
    <Seo
      title="Insights — NEXREQ UAE & GCC"
      siteName="NEXREQ"
      description="GCC hiring intelligence, salary benchmarks and talent advisory perspectives from NEXREQ consultants."
    />
    <PageHero
      eyebrow="Insights"
      lines={["Intelligence for", "Decisive Leaders."]}
      description="Market reports, salary guides and advisory perspectives from consultants who operate inside the GCC talent market every day."
      image={img("photo-1431540015161-0bf868a2d407", 1920)}
    />

    <section className="bg-obsidian py-24 lg:py-28" data-testid="insights-grid">
      <div className="nx-container grid gap-x-10 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
        {INSIGHTS.map((a, i) => (
          <Reveal key={a.title} delay={(i % 3) * 0.08}>
            <article className="group cursor-pointer" data-testid={`insight-article-${i}`}>
              <div className="overflow-hidden">
                <img
                  src={img(a.image, 900)}
                  alt={a.title}
                  className="aspect-[4/3] w-full object-cover grayscale-[35%] transition duration-700 group-hover:scale-105 group-hover:grayscale-0"
                  loading="lazy"
                />
              </div>
              <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-emerald-500">{a.tag}</p>
              <h2 className="mt-3 font-heading text-xl font-light leading-snug text-white transition-colors group-hover:text-emerald-400">
                {a.title}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-white/45">{a.excerpt}</p>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
                {a.date} · {a.readTime}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
      <p className="nx-container mt-16 border-t border-white/10 pt-8 text-sm text-white/35" data-testid="insights-note">
        Full reports and bespoke market briefings are available to NEXREQ clients on request —{" "}
        <a href="mailto:info@nexreq.ae" className="text-emerald-400 hover:underline" data-testid="insights-email-link">
          info@nexreq.ae
        </a>
        .
      </p>
    </section>
  </>
);

export default Insights;
